/* eslint-disable curly */
import React, { Component, useEffect, useState } from "react";
import {
  View,
  Text,
  TextInput,
  ImageBackground,
  Platform,
  KeyboardAvoidingView,
} from "react-native";
import { StackActions, NavigationActions } from "react-navigation";

import ButtonConfirm from "../../components/ButtonConfirm";
import Loading from "../../components/Loading";
import { registarSenha } from "../../services/aluno-service";
import { getAluno, onSignIn } from "../../services/auth-service";
import { alert } from "../../utils/alerts";

import styles from "./styles";

function DefinirSenha(props) {
  const [senha, setSenha] = useState("");
  const [aluno, setAluno] = useState({ nome: "" });
  const [loading, setLoading] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);

  const validado = () => {
    if (!senha) {
      alert("Ops...", "Preencha a senha");
      return false;
    }
    return true;
  };

  const salvarSenha = async () => {
    if (!validado()) return;

    setLoading(true);

    let aluno = await getAluno();

    const alunoAtualizar = {};
    alunoAtualizar.cpf = aluno.cpf;
    alunoAtualizar.senha = senha;

    try {
      const response = await registarSenha(alunoAtualizar);

      if (!response.ok) {
        setLoading(false);

        return alert(
          "Ops...",
          "Houve algum problema ao salvar a senha, tente novamente mais tarde"
        );
      }
      const alunoSessao = await response.json();

      // alunoSessao.aluno = aluno

      onSignIn(alunoSessao);

      setLoading(false);

      const navigateAction = StackActions.reset({
        index: 0,
        actions: [NavigationActions.navigate({ routeName: "SignedIn" })],
      });

      props.navigation.dispatch(navigateAction);
    } catch (erro) {
      console.log(erro);
    }
  };

  useEffect(() => {
    const carregarAluno = async () => {
      setAluno(await getAluno());
    };

    carregarAluno();
  }, []);

  const handlerSenha = (e) => {
    setSenha(e);
    setConfirmDisabled(e.length < 4);
  };

  return (
    <>
      {loading && <Loading />}
      {aluno.nome !== "" && (
        <KeyboardAvoidingView
          style={styles.container}
          behavior={Platform.select({
            ios: "padding",
            android: "null",
          })}
          keyboardVerticalOffset={Platform.select({ ios: 0, android: 0 })}
        >
          <ImageBackground
            source={require("../../../resources/imgs/bg.jpg")}
            style={styles.container}
            imageStyle={styles.imageContainer}
          >
            <View style={styles.containerForm}>
              <Text style={styles.textHeader1}>
                Bom ter ver por aqui, {aluno.nome.split(" ").shift()}
              </Text>
              <Text style={styles.textHeader2}>
                Agora, defina uma senha para futuros acessos:
              </Text>
              <TextInput
                style={styles.input}
                placeholder="Sua senha..."
                placeholderTextColor="#ccc"
                secureTextEntry={true}
                autoFocus={true}
                onChangeText={handlerSenha}
              />
              <ButtonConfirm
                text="Entrar"
                disabled={confirmDisabled}
                onPress={salvarSenha}
                msgDisabled="Por favor, preencha uma senha com no mínimo 3 caracteres"
              />
            </View>
          </ImageBackground>
        </KeyboardAvoidingView>
      )}
    </>
  );
}

export default DefinirSenha;
